import KabristanDashboard from "../components/KabristanDashboard";
export default function KabristanDashboad() {
  return (
    <KabristanDashboard />  );  }